import { type ServiceDescriptor } from '@luvio/utils';
import { CacheControlCommand } from './cache-control-command';

export { CacheControlCommand } from './cache-control-command';
export { CacheControlRequestRunner } from './cache-control-request-runner';

export type CacheControlCommandServiceDescriptor = ServiceDescriptor<
    typeof CacheControlCommand,
    'cacheControlCommandBaseClass',
    '1.0'
>;

export function buildServiceDescriptor(): CacheControlCommandServiceDescriptor {
    return {
        type: 'cacheControlCommandBaseClass',
        version: '1.0',
        service: CacheControlCommand,
    };
}
